// extracted by mini-css-extract-plugin
export default {"loader":"ProcessingStage_loader__2sgCa","text":"ProcessingStage_text__M8O2n"};